export default __webpack_public_path__ + "static/media/alert_success_icon.3ec7a903.svg";